export function setItems(state, payload) {
  state.items = payload;
}

export function setLoading(state, payload) {
  state.isLoading = payload;
}
